import React, {useRef} from "react";
import {gsap, Power2} from "gsap";
import {useNavigate} from "react-router-dom";
import {useCursor} from "../../Cursor/MagicCursorProvider";
import "./MagneticButton.css";

const MagneticButton = ({
  children,
  to = "/",
  className = "",
  type = "button",
}) => {
  const wrapRef = useRef(null);
  const itemRef = useRef(null);
  const navigate = useNavigate();
  const {setCursorStyle, setCursorText} = useCursor();

  const parallax = (e, parent, target, movement) => {
    const rect = parent.getBoundingClientRect();
    const relX = e.clientX - rect.left;
    const relY = e.clientY - rect.top;

    gsap.to(target, {
      duration: 0.3,
      x: ((relX - rect.width / 2) / rect.width) * movement,
      y: ((relY - rect.height / 2) / rect.height) * movement,
      ease: Power2.easeOut,
    });
  };

  const handleMouseMove = (e) => {
    if (wrapRef.current && itemRef.current) {
      parallax(e, wrapRef.current, itemRef.current, 25);
    }
  };

  const handleEnter = () => {
    const ball = document.getElementById("ball");
    if (!ball) return;

    gsap.to(ball, {width: 70, height: 70, duration: 0.3});
    ball.classList.add("magnetic-active");
  };

  const handleLeave = () => {
    const ball = document.getElementById("ball");
    if (!ball) return;

    gsap.to(ball, {width: 36, height: 36, duration: 0.3});
    ball.classList.remove("magnetic-active");

    if (itemRef.current) {
      gsap.to(itemRef.current, {
        x: 0,
        y: 0,
        clearProps: "all",
        duration: 0.3,
      });
    }
  };

  const handleClick = (e) => {
    e.preventDefault();

    const ball = document.getElementById("ball");

    // Reset context
    setCursorStyle("");
    setCursorText("");

    // Reset DOM state immediately
    if (ball) {
      gsap.to(ball, {width: 36, height: 36, duration: 0.2});
      ball.classList.remove("magnetic-active");
    }

    // Give a short delay for cursor reset animation
    setTimeout(() => {
      navigate(to);
    }, 120);
  };

  return (
    <div
      className="magnetic-wrap"
      ref={wrapRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
    >
      <div className="magnetic-item" ref={itemRef}>
        <a href={to} onClick={handleClick} className={className} type={type}>
          {children}
        </a>
      </div>
    </div>
  );
};

export default MagneticButton;
